const animations = document.querySelectorAll('[data-animation]');
	if ( animations ) {
		window.addEventListener('scroll', (e) => {
			animations.forEach((animation) => {
				let flag = false;
				if ( isScrolledIntoView( animation ) ) {
					addAnimation( animation );
					flag = true;
				}
			});
		});

		animations.forEach((animation) => {
			if ( isScrolledIntoView( animation ) ) {
				addAnimation( animation );
			}
		});
	}

function addAnimation( element ) {
	let animation = element.getAttribute('data-animation');
	let delay     = element.getAttribute('data-delay');
	element.classList.add( animation );
	if ( delay != undefined ) {
		element.style.animationDelay = delay + 'ms';
	} else {
		element.style.animationDelay = '0.3s';
	}
}

function isScrolledIntoView(elem) {
	const docViewTop = window.scrollY;
	const docViewBottom = docViewTop + ( window.innerHeight + 400 ); // 400px offset for earlier response

	const elemTop    = elem.getBoundingClientRect().top + docViewTop;
	const elemBottom = elemTop + ( window.innerHeight * 0.6 );

	return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}